(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335],{

/***/ 81382:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(9732);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(7500);
// EXTERNAL MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(12963);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(29769);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/index.js
var next_translate_routes = __webpack_require__(18633);
;// CONCATENATED MODULE: ./src/utils/filter-breadcrumbs.ts

function filterBreadcrumbs(useCollectionCrumbs, data, locale, currentCollection) {
    var ref;
    var url = "".concat((ref = "https://fun.libero.it/") === null || ref === void 0 ? void 0 : ref.replace(/\/+$/, ""));
    var breadcrumbs = data;
    if (useCollectionCrumbs) {
        var filteredCrumbs = breadcrumbs.filter(function(crumb) {
            var ref;
            return !(crumb === null || crumb === void 0 ? void 0 : (ref = crumb.type) === null || ref === void 0 ? void 0 : ref.includes("category"));
        });
        if ((currentCollection === null || currentCollection === void 0 ? void 0 : currentCollection.name) && (currentCollection === null || currentCollection === void 0 ? void 0 : currentCollection.slug)) {
            return filteredCrumbs.map(function(crumb) {
                var translatedCollection = (0,next_translate_routes.translateUrl)("/collection/".concat(crumb.code), locale);
                if (crumb.path.includes(translatedCollection)) {
                    return {
                        href: "".concat(url).concat((0,next_translate_routes.translateUrl)("/collection/".concat(currentCollection.slug), locale)),
                        path: "".concat((0,next_translate_routes.translateUrl)("/collection/".concat(currentCollection.slug), locale)),
                        name: currentCollection.name
                    };
                }
                return crumb;
            });
        }
        return filteredCrumbs;
    } else {
        return breadcrumbs.filter(function(crumb) {
            var translatedCollection = (0,next_translate_routes.translateUrl)("/collection/".concat(crumb.code), locale);
            return !crumb.path.includes(translatedCollection);
        });
    }
}

;// CONCATENATED MODULE: ./src/components/BreadCrumbs/BreadCrumbs.tsx











var BreadCrumbs_Link = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Link/* Link */.r, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
function BreadCrumbs(props) {
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "breadcrumb"
    ]).t;
    var breadcrumbFilter = props.breadcrumbs.map(function(breadcrumb) {
        return breadcrumb.path === "/" ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, breadcrumb), {
            name: t("breadcrumb:home")
        }) : breadcrumb;
    });
    var currentCollection = appContext.useCollectionCrumbs().currentCollection;
    var ref = appContext.useConfig(), languageCode = ref.languageCode, componentOptions = ref.componentOptions;
    var breadcrumbs = filterBreadcrumbs(componentOptions.component_use_collection_crumbs || false, breadcrumbFilter, languageCode, currentCollection);
    var theme = (0,useTheme/* default */.Z)();
    var crumbRefs = react.useRef([]);
    // Todo: Fix crumbRefs.current typescript problem.
    // @ts-ignore
    crumbRefs.current = breadcrumbs.map(function(crumb, index) {
        var _index;
        // @ts-ignore
        return (_index = crumbRefs.current[index]) !== null && _index !== void 0 ? _index : /*#__PURE__*/ react.createRef();
    });
    if (!(props === null || props === void 0 ? void 0 : props.hidden)) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumbs/* default */.Z, {
        "aria-label": "breadcrumb",
        sx: {
            margin: theme.spacing(2, 0)
        },
        children: breadcrumbs.map(function(crumb, index) {
            return breadcrumbs[breadcrumbs.length - 1] ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs_Link, {
                // @ts-ignore
                ref: crumbRefs.current[index],
                underline: "hover",
                color: "text.primary",
                href: crumb.path,
                "aria-current": "page",
                variant: "body2",
                sx: {
                    textTransform: "none"
                },
                children: crumb.name === "Home" ? t("home", "Home") : crumb.name
            }, index) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs_Link, {
                // @ts-ignore
                ref: crumbRefs.current[index],
                underline: "hover",
                color: "inherit",
                href: crumb.path,
                variant: "body2",
                sx: {
                    textTransform: "none"
                },
                children: crumb.name
            }, index);
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
}

;// CONCATENATED MODULE: ./src/components/BreadCrumbs/index.ts



/***/ }),

/***/ 78958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useHighlightHandlers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54794);







// Todo: Have a hard time setting the type for Component, as it can be Mui Typography or our own Link component.
var useHighlightHandlers = function(Component, props) {
    var enabledVariants = (0,_index__WEBPACK_IMPORTED_MODULE_1__/* .useHighlightContext */ .A)().enabledVariants;
    var forwardedRef = props.forwardedRef, variant = props.variant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "forwardedRef",
        "variant"
    ]);
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var element = null;
    // Todo: Not sure how to resolve this missing current ts warning.
    // @ts-ignore
    if (forwardedRef && (forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current)) {
        // Todo: Not sure how to resolve this missing current ts warning.
        // @ts-ignore
        element = forwardedRef.current;
    }
    if (element && variant && Array.isArray(enabledVariants)) {
        if (enabledVariants.includes(variant)) {
            element.style.outline = "2px dotted ".concat(theme.palette.info.main);
            element.style.outlineOffset = "-2px";
            element.style.position = "relative";
            if (!element.querySelector(".typographyBadge")) {
                var badge = document.createElement("div");
                badge.classList.add("typographyBadge");
                badge.style.position = "absolute";
                badge.style.top = theme.spacing(-0.5);
                badge.style.right = theme.spacing(-0.5);
                badge.style.backgroundColor = theme.palette.info.main;
                badge.style.borderRadius = "".concat(theme.shape.borderRadius, "px");
                badge.style.color = theme.palette.info.contrastText;
                badge.style.fontSize = "10px";
                badge.style.lineHeight = "10px";
                badge.style.padding = theme.spacing(0.5, 1);
                badge.style.boxShadow = theme.shadows[1];
                badge.style.textTransform = "capitalize";
                badge.innerText = [
                    "contained",
                    "text",
                    "outlined"
                ].includes(variant) ? "button" : variant;
                element.appendChild(badge);
            }
        } else {
            var ref;
            element.style.outline = "unset";
            (ref = element.querySelector(".typographyBadge")) === null || ref === void 0 ? void 0 : ref.remove();
        }
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        variant: variant,
        ref: forwardedRef
    }));
};


/***/ }),

/***/ 9732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ ContactPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./src/app/api.ts
var api = __webpack_require__(9672);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(21122);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 16 modules
var TextField = __webpack_require__(84458);
// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 6 modules
var Alert = __webpack_require__(21737);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
;// CONCATENATED MODULE: ./src/components/ContactForm/ContactForm.tsx













var initialFormValues = {
    source: "customer",
    subject: "",
    name: "",
    email: "",
    message: "",
    submitted: false,
    success: false
};
var ContactForm = function(props) {
    var onSubmit = props.onSubmit;
    var t = (0,useTranslation/* useTranslation */.$)("contact_form").t;
    var theme = (0,useTheme/* default */.Z)();
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(initialFormValues), 2), values = ref[0], setValues = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState({}), 2), errors = ref1[0], setErrors = ref1[1];
    var validate = function() {
        var fieldValues = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : values;
        var temp = (0,_object_spread/* default */.Z)({}, errors);
        if ("name" in fieldValues) {
            temp.name = fieldValues.name ? "" : t("field_required", "This field is required.");
        }
        if ("email" in fieldValues) {
            temp.email = fieldValues.email ? "" : t("field_required", "This field is required.");
            if (fieldValues.email) temp.email = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(fieldValues.email) ? "" : t("field_email_invalid", "Email is not valid.");
        }
        if ("subject" in fieldValues) {
            temp.subject = fieldValues.subject.length !== 0 ? "" : t("field_required", "This field is required.");
        }
        if ("message" in fieldValues) {
            temp.message = fieldValues.message.length !== 0 ? "" : t("field_required", "This field is required.");
        }
        setErrors((0,_object_spread/* default */.Z)({}, temp));
    };
    var handleInputValue = function(e) {
        var _target = e.target, name = _target.name, value = _target.value;
        setValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), (0,_define_property/* default */.Z)({}, name, value)));
        validate((0,_define_property/* default */.Z)({}, name, value));
    };
    var handleSuccess = function() {
        setValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialFormValues), {
            submitted: true,
            success: true
        }));
    };
    var handleError = function() {
        setValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialFormValues), {
            submitted: true,
            success: false
        }));
    };
    var formIsValid = function() {
        var fieldValues = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : values;
        return fieldValues.name && fieldValues.email && fieldValues.message && Object.values(errors).every(function(x) {
            return x === "";
        });
    };
    var handleFormSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var isValid, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        isValid = Object.values(errors).every(function(x) {
                            return x === "";
                        }) && formIsValid();
                        if (!isValid) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            onSubmit({
                                source: values.source,
                                subject: values.subject,
                                name: values.name,
                                email: values.email,
                                message: values.message
                            })
                        ];
                    case 2:
                        _state.sent();
                        handleSuccess();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        handleError();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleFormSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            values.success && values.submitted && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Alert/* default */.Z, {
                severity: "success",
                sx: {
                    margin: theme.spacing(2, 0)
                },
                children: t("success", "Thanks for reaching out!")
            }),
            !values.success && values.submitted && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Alert/* default */.Z, {
                severity: "error",
                sx: {
                    margin: theme.spacing(2, 0)
                },
                children: t("error", "We are currently unable to complete your transaction!")
            }),
            !values.submitted && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
                onSubmit: handleFormSubmit,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
                        name: "name",
                        onBlur: handleInputValue,
                        onChange: handleInputValue,
                        label: t("name", "Name"),
                        fullWidth: true,
                        autoComplete: "none",
                        margin: "dense"
                    }, errors["name"] && {
                        error: true,
                        helperText: errors["name"]
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
                        name: "email",
                        onBlur: handleInputValue,
                        onChange: handleInputValue,
                        label: t("email", "Email"),
                        fullWidth: true,
                        autoComplete: "none",
                        margin: "dense"
                    }, errors["email"] && {
                        error: true,
                        helperText: errors["email"]
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
                        name: "subject",
                        onBlur: handleInputValue,
                        onChange: handleInputValue,
                        label: t("subject", "Subject"),
                        fullWidth: true,
                        autoComplete: "none",
                        margin: "dense"
                    }, errors["subject"] && {
                        error: true,
                        helperText: errors["subject"]
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
                        name: "message",
                        onBlur: handleInputValue,
                        onChange: handleInputValue,
                        label: t("message", "Message"),
                        fullWidth: true,
                        multiline: true,
                        rows: 5,
                        autoComplete: "none",
                        margin: "dense"
                    }, errors["message"] && {
                        error: true,
                        helperText: errors["message"]
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                        type: "submit",
                        variant: "contained",
                        disabled: !formIsValid(),
                        children: t("send_message", "Send")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/ContactForm/index.ts


// EXTERNAL MODULE: ./src/components/BreadCrumbs/index.ts + 2 modules
var BreadCrumbs = __webpack_require__(70055);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 2 modules
var Container = __webpack_require__(53156);
;// CONCATENATED MODULE: ./src/containers/ContactA/ContactA.tsx










var ContactA_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var ContactA = function(props) {
    var pageContext = props.pageContext, body = props.body, title = props.title;
    var theme = (0,useTheme/* default */.Z)();
    var titleRef = react.useRef(null);
    var bodyRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
                maxWidth: "md",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs/* BreadCrumbs */.b, {
                    breadcrumbs: pageContext.breadcrumbs
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, {
                maxWidth: "md",
                sx: {
                    marginBottom: theme.spacing(2)
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContactA_Typography, {
                        ref: titleRef,
                        component: "h1",
                        variant: "h1",
                        mb: 2,
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContactA_Typography, {
                        ref: bodyRef,
                        component: "p",
                        variant: "body1",
                        mb: 1,
                        children: body
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContactForm, {
                        onSubmit: api/* postContactMessage */.Ms
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/containers/ContactA/index.ts


;// CONCATENATED MODULE: ./src/generated/contact/index.tsx




function View(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContactA, (0,_object_spread/* default */.Z)({}, props))
    });
}

// EXTERNAL MODULE: ./src/layouts/BaseLayout/index.tsx + 5 modules
var BaseLayout = __webpack_require__(92176);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(29769);
// EXTERNAL MODULE: ./src/utils/localize-helpers.ts
var localize_helpers = __webpack_require__(98751);
;// CONCATENATED MODULE: ./src/pages/contact.tsx




// import { ContactA as View } from '../containers/ContactA';






var __N_SSG = true;
function ContactPage(props) {
    var pageContext = props.pageContext;
    var ref = (0,esm/* useTranslation */.$G)([
        "common",
        "contact"
    ]), t = ref.t, i18n = ref.i18n;
    var router = (0,next_router.useRouter)();
    var paths = (0,localize_helpers/* getLocalizedPaths */.mT)(router);
    var slugs = (0,localize_helpers/* getLocalizedSlugs */.fD)(router);
    var pageContextWithPaths = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageContext), {
        paths: paths,
        slugs: slugs,
        slug: (0,localize_helpers/* cleanSlug */.Hm)(router.pathname)
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* NextSeo */.PB, {
                title: i18n.exists("contact:title", {
                    fallbackLng: pageContextWithPaths.locale
                }) ? t("contact:title") : t("common:title"),
                description: i18n.exists("contact:description", {
                    fallbackLng: pageContextWithPaths.locale
                }) ? t("contact:description") : t("common:description")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* BreadcrumbJsonLd */.gR, {
                itemListElements: pageContextWithPaths.breadcrumbs.map(function(crumb, index) {
                    return {
                        position: index + 1,
                        name: crumb.name,
                        item: crumb.href
                    };
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(View, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                title: i18n.exists("contact:headline", {
                    fallbackLng: pageContextWithPaths.locale
                }) ? t("contact:headline") : t("common:headline"),
                body: i18n.exists("contact:body", {
                    fallbackLng: pageContextWithPaths.locale
                }) ? t("contact:body") : t("common:body"),
                pageContext: pageContextWithPaths
            }))
        ]
    });
}
// Adding getLayout property. Allowing us to return a React component for the layout.
// This allows us to define the layout on a per-page basis. Since we're returning a function,
// we can have complex nested layouts if desired.
ContactPage.getLayout = function getLayout(page) {
    var props = page.props;
    var pageContext = props.pageContext;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BaseLayout/* BaseLayout */.I, {
        pageType: "contact",
        pageContext: pageContext,
        children: page
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2906,978,2214,473,89,9514,2607,9050,1262,3500,9774,2888,179], function() { return __webpack_exec__(81382); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);